module.exports = __webpack_public_path__ + "static/media/hallbart_square.70e8586f.png";